// Converts a decimal fraction (e.g. 0.05) into its percentage representation
// (e.g. 5), ready to be passed to formatPercentageToReadableValue.
export const convertDecimalToPercentage = (decimal: number) => decimal * 100;
